import emitter from "@/utils/emitter";

/**
 * Emit an error alert globally
 * @param {string} messageKeyOrText - Message text or i18n key
 * @param {Function|null} t - Translation function (optional)
 * @param {Object} options - Optional overrides (e.g. duration)
 */
export function showError(messageKeyOrText, t = null, options = {}) {
  const message =
    t && typeof messageKeyOrText === "string"
      ? t(messageKeyOrText)
      : messageKeyOrText;

  const payload = {
    message,
    icon: "error",
    bgColor: "alert-danger",
    duration: options.time ?? 5000,
    ...options,
  };

  //console.log("[GlobalAlert] showError:", payload); 
  emitter.emit("trigger-error", payload);
}

/**
 * Emit a success alert globally
 * @param {string} messageKeyOrText - Message text or i18n key
 * @param {Function|null} t - Translation function (optional)
 * @param {Object} options - Optional overrides (e.g. duration)
 */
export function showSuccess(messageKeyOrText, t = null, options = {}) {
  const message =
    t && typeof messageKeyOrText === "string"
      ? t(messageKeyOrText)
      : messageKeyOrText;

  const payload = {
    message,
    icon: "check_circle",
    bgColor: "alert-success",
    duration: options.time ?? 5000,
    ...options
  };

  //console.log("[GlobalAlert] showSuccess:", payload); 
  emitter.emit("trigger-error", payload);  
}
